import { MarketingAutomationCustomerResult } from "src/api-service";

// **************************************************************************
// SEND REMINDER STATE
// **************************************************************************
export interface SendReminderState {
    sendingCustomerSystemIds: string[];
    lastResult: MarketingAutomationCustomerResult | undefined;
    loading: boolean;
}

export const initialSendReminderState: SendReminderState = {
    sendingCustomerSystemIds: [],
    lastResult: undefined,
    loading: false,
};
